export default "__VITE_ASSET__ClnRj78i__"